import ShippingLabelToPrint from './ShippingLabelToPrint';
import { withI18n } from 'react-i18next';

export default ShippingLabelToPrint;
